<template>
  <sPopover
    ref="popoverTag"
    placement="right"
    trigger="click"
    width="400">
    <div class="py-2">
      <div
        v-for="(group, groupIndex) in groupTag"
        :key="group.title"
        class="tag-list">
        <div class="width-100 mb-2 px-3 bold">
          {{ $t(group.title) }}
        </div>
        <MenuItem
          v-for="tag in group.items"
          :key="tag.key"
          class="tag-list__item"
          :data-qa="`tag-${tag.key}`"
          :icon="tag.icon"
          :label="tag.label"
          @click="addedTag(tag.key)"/>
        <sDivider
          v-if="groupIndex!==groupTag.length-1"
          class="width-100 my-3"/>
      </div>
    </div>
    <div
      slot="reference"
      class="pointer">
      <sIcon
        rotate="45"
        type="circle-line"/>
    </div>
  </sPopover>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import automations from 'mixins/automations'

export default {
  name: 'AutomationTags',
  mixins: [ automations ],
  methods: {
    addedTag(tag) {
      this.$refs.popoverTag.showPopper = false
      this.$emit('addedTag', tag)
    }
  },
  computed: {
    groupTag() {
      const result = []
      this.mixin_spr.tags.forEach(tag => {
        const group = result.find(i => i.title === tag.group)
        if (!group) {
          result.push({
            title: tag.group,
            items: [tag]
          })
        } else {
          group.items.push(tag)
        }
      })
      return result
    }
  },
  components: {
    MenuItem,
  },
  i18n: {
    messages: {
      uk: {
        tender_prop: 'Властивості тендера',
        count_prop: 'Кількість',
        has_prop: 'Наявність',
        key_prop: 'Код',
        var_prop: 'Змінна',
      },
      ru: {
        tender_prop: 'Свойстватендера ',
        count_prop: 'Количество',
        has_prop: 'Наличие',
        key_prop: 'Код',
        var_prop: 'Переменная',
      },
      en: {
        tender_prop: 'Tender properties',
        count_prop: 'Count',
        has_prop: 'Presence',
        key_prop: 'Key',
        var_prop: 'Variable',
      },
    }
  }
}
</script>
<style scoped lang="scss">
.tag-list {
  max-height: 400px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  &__item {
    font-size: 0.75rem !important;
    width: 50%;
    height: 30px !important;
  }
}
</style>
